import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { COOKIE_KEY } from '@/config/constanta';

import { TokenManager } from '@/Router/services/TokenManager';
import PIN_IMAGE from 'Image/PIN/PIN.png';
import { Button, HStack, Typography, VStack } from '@ajaibid/components';
import {
  PIN_ENTRY_POINT,
  PIN_UPDATE_BANNER_CLICK_TARGET,
  PIN_UPDATE_BANNER_VARIANT,
} from '@services/trackerConst';
import { FullScreenWrapper, StyledContainer } from './style';
import useEventTracker from './tracker';

const RenewPin = () => {
  const navigate = useNavigate();
  const { eventPinUpdateBannerView, eventPinUpdateBannerClick } = useEventTracker();

  // This screen always offers "Nanti Saja", so the banner is always the optional variant here.
  // The forced variant would come from the PIN reminder API's is_skippable, which this app
  // does not act on yet.
  const variant = PIN_UPDATE_BANNER_VARIANT.OPTIONAL;

  useEffect(() => {
    eventPinUpdateBannerView(PIN_ENTRY_POINT.LOGIN, variant);
  }, []);

  const handeUpdatePin = () => {
    eventPinUpdateBannerClick(
      PIN_ENTRY_POINT.LOGIN,
      variant,
      PIN_UPDATE_BANNER_CLICK_TARGET.UPDATE_PIN
    );
    TokenManager.setCookieData(COOKIE_KEY.pin_need_change, 'true');
    navigate('/create-pin');
  };

  const handleUpdateLater = () => {
    eventPinUpdateBannerClick(PIN_ENTRY_POINT.LOGIN, variant, PIN_UPDATE_BANNER_CLICK_TARGET.SKIP);
    TokenManager.setCookieData(COOKIE_KEY.pin_need_change, 'false');
    navigate('/home');
  };
  return (
    <FullScreenWrapper>
      <StyledContainer>
        <VStack top="24px" bottom="24px" align="center">
          <img src={PIN_IMAGE} alt="" width="320px" />
        </VStack>

        <Typography type="heading" size="sm" textAlign="center">
          Perbarui PIN
        </Typography>
        <Typography type="body" textAlign="center">
          Untuk meningkatkan keamanan kamu dalam menggunakan Ajaib, segera perbarui PIN kamu menjadi
          6 digit angka.
        </Typography>

        <HStack top="24px">
          <Button variant="secondary" size="md" fluid onClick={handleUpdateLater}>
            Nanti Saja
          </Button>
          <div style={{ width: 8 }} />
          <Button variant="primary" size="md" fluid onClick={handeUpdatePin}>
            Perbarui PIN
          </Button>
        </HStack>
      </StyledContainer>
    </FullScreenWrapper>
  );
};

export default RenewPin;
